/** Drawer form rules, mirroring the backend (POST admin/stations/fuel-prices). */

export const PRICE_MAX = 100;
const PLACE_ID_RE = /^[A-Za-z0-9_-]+$/;

/** Returns an error message, or undefined when the price is valid (> 0, ≤ 100, ≤ 3 decimals). */
export function validatePrice(raw) {
  const text = String(raw ?? '').trim().replace(',', '.');
  if (!text) return 'Enter the price.';
  if (!/^\d*\.?\d+$/.test(text)) return 'Enter a number, e.g. 1.879.';
  const value = Number(text);
  if (value <= 0) return 'The price must be more than 0.';
  if (value > PRICE_MAX) return `The price can be at most €${PRICE_MAX}.`;
  if (!/^\d+(\.\d{1,3})?$/.test(text)) return 'Use at most 3 decimals.';
  return undefined;
}

export const parsePrice = (raw) => Number(String(raw).trim().replace(',', '.'));

/** Google place IDs only contain letters, digits, "_" and "-". */
export function validatePlaceId(raw) {
  const text = String(raw ?? '').trim();
  if (!text) return 'Select a station or paste its Place ID.';
  if (!PLACE_ID_RE.test(text)) return 'A Place ID only contains letters, digits, "_" and "-".';
  if (text.length > 300) return 'This Place ID is too long.';
  return undefined;
}

/**
 * Maps the backend's field errors (e.g. "prices[0].latestPrice", "placeId") onto the
 * drawer's fields; anything else is returned as `general`.
 */
export function mapServerErrors(fieldErrors = []) {
  const errors = {};
  const general = [];
  for (const { field, message } of fieldErrors) {
    if (/^prices\[\d+\]\.latestPrice$/.test(field ?? '')) errors.price = message;
    else if (/^prices\[\d+\]\.fuelOptionId$/.test(field ?? '')) errors.fuelOptionId = message;
    else if (field === 'placeId') errors.placeId = message;
    else general.push(message);
  }
  return { errors, general };
}
